import type { Router } from '@angular/router';

import type { SessionPhase } from './models/session-room.models';

/** Minimal shape shared by Hub sessions and agenda items. */
export interface SessionNavigationTarget {
  sessionId: number;
  roomId: number;
  phase?: SessionPhase;
}

/**
 * Pre-event sessions linked to a catalogue room should open the Stage /
 * Auditorium room surface (booth profile with `?roomId=`), not the Session
 * Room pre-event countdown card.
 */
export function shouldOpenStageRoom(
  phase: SessionPhase | undefined,
  roomId: number
): boolean {
  return phase === 'pre-event' && roomId > 0;
}

/** Native Stage / Auditorium room — MOB-100 maps legacy Auditorium → Stage. */
export function navigateToStageRoom(
  router: Router,
  roomId: number
): Promise<boolean> {
  return router.navigate(['/tabs/booths', String(roomId)], {
    queryParams: { roomId }
  });
}

/** Full-screen Session Room (live / post-event / join). */
export function navigateToSessionRoom(
  router: Router,
  sessionId: number
): Promise<boolean> {
  return router.navigate(['/session', String(sessionId)]);
}

export function navigateToSessionOrRoom(
  router: Router,
  target: SessionNavigationTarget
): Promise<boolean> {
  if (shouldOpenStageRoom(target.phase, target.roomId)) {
    return navigateToStageRoom(router, target.roomId);
  }
  return navigateToSessionRoom(router, target.sessionId);
}

/** Deep-link / push `landingType=Stage` target id is a room id. */
export function stageRoomPath(roomId: number): string {
  return `/tabs/booths/${roomId}?roomId=${roomId}`;
}
